module.exports = __webpack_public_path__ + "img/@logo_steel1.94421110.png";